import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Download } from "lucide-react";
import { Logo, Wordmark } from "./Logo";

const links = [
  { label: "Services", id: "services" },
  { label: "Process", id: "process" },
  { label: "Work", id: "work" },
  { label: "About", id: "about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#050505]/85 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3">
          <Logo />
          <Wordmark />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-white/60 hover:text-[#F5B841] transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-brochure-btn"
            href="/bhaaskar-brochure.pdf"
            download="Bhaaskar-Productions-Brochure.pdf"
            className="inline-flex items-center gap-2 text-sm text-white/70 border border-white/20 px-4 py-2.5 hover:border-[#F5B841] hover:text-[#F5B841] transition-colors"
          >
            <Download className="w-4 h-4" /> Brochure
          </a>
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("quote")}
            className="bg-[#F5B841] text-black text-sm font-semibold px-5 py-2.5 hover:bg-white transition-colors"
          >
            Request a Quote
          </button>
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden backdrop-blur-xl bg-[#050505]/95 border-b border-white/10 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button key={l.id} onClick={() => go(l.id)} className="text-left text-white/70 hover:text-[#F5B841]">
                  {l.label}
                </button>
              ))}
              <a
                data-testid="nav-brochure-mobile"
                href="/bhaaskar-brochure.pdf"
                download="Bhaaskar-Productions-Brochure.pdf"
                className="inline-flex items-center gap-2 text-white/70 border border-white/20 px-5 py-3"
              >
                <Download className="w-4 h-4" /> Download Brochure
              </a>
              <button onClick={() => go("quote")} className="bg-[#F5B841] text-black font-semibold px-5 py-3 mt-1">
                Request a Quote
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
